import { __extends } from "tslib";
import { Rectangle, Point } from '@awayjs/core';
import { ContextGLProgramType } from '../../../base/ContextGLProgramType';
import { Filter3DTaskBaseWebGL } from './Filter3DTaskBaseWebgGL';
var EMPTY_TRANSFORM = new Float32Array([1, 1, 1, 1, 0, 0, 0, 0]);
var VERTEX = "\nprecision highp float;\nuniform float yflip;\nuniform vec4 vc[2];\nvec4 vt0;\n\n/* AGAL legacy atrib resolver require this names */\nattribute vec4 va0; // position\nattribute vec4 va1; // uv \n\nvarying vec2 vUv;\n\nvoid main() {\n\tvec4 pos = va0;\n\n\tpos.xy = pos.xy * vc[0].zw + vc[0].xy;\n\tpos.z = pos.z * 2.0 - pos.w;\n\n\tvUv = (va1.xy + vc[1].xy) * vc[1].zw;\n\n    gl_Position = pos;\n}\n\n";
var FRAG = "\nprecision highp float;\nuniform vec4 fc[2];\nvarying vec2 vUv;\n\n/* AGAL legacy attrib resolver require this names */\nuniform sampler2D fs0;\n\nvoid main() {\n\tvec4 color = texture2D(fs0, vUv);\n\t\n\tif (color.a > 0.0) {\n\t\tcolor.rgb /= color.a;\n\t}\n\n\t// mult\n\tcolor *= clamp(fc[0], 0.0, 1.0);\t\n\tcolor += fc[1];\n\n\tcolor.rgb *= color.a;\n\n    gl_FragColor = color;\n}";
var Filter3DCopyPixelTaskWebGL = /** @class */ (function (_super) {
    __extends(Filter3DCopyPixelTaskWebGL, _super);
    function Filter3DCopyPixelTaskWebGL() {
        var _this = _super.call(this) || this;
        _this.rect = new Rectangle();
        _this.destPoint = new Point();
        _this._inputTextureIndex = 0;
        _this._positionIndex = 0;
        _this._uvIndex = 1;
        _this._vertexConstantData = new Float32Array([
            0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0
        ]);
        _this._fragConstantData = EMPTY_TRANSFORM.slice();
        return _this;
    }
    Object.defineProperty(Filter3DCopyPixelTaskWebGL.prototype, "sourceTexture", {
        get: function () {
            return this._mainInputTexture;
        },
        set: function (value) {
            this._mainInputTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    Filter3DCopyPixelTaskWebGL.prototype.getVertexCode = function () {
        return VERTEX;
    };
    Filter3DCopyPixelTaskWebGL.prototype.getFragmentCode = function () {
        return FRAG;
    };
    Filter3DCopyPixelTaskWebGL.prototype.getMainInputTexture = function (stage) {
        return this._mainInputTexture;
    };
    Filter3DCopyPixelTaskWebGL.prototype.activate = function (stage, projection, depthTexture) {
        var index = 0; //this._positionIndex;
        var vd = this._vertexConstantData;
        var dp = this.destPoint;
        var sr = this.rect;
        var tr = this._target;
        var tex = this._mainInputTexture;
        // mul to vertex
        vd[index + 0] = (2 * dp.x + sr.width) / tr.width - 1;
        vd[index + 1] = (2 * dp.y + sr.height) / tr.height - 1;
        // add to vertex
        vd[index + 2] = sr.width / tr.width;
        vd[index + 3] = sr.height / tr.height;
        // add to uv
        vd[index + 4] = sr.x / sr.width;
        vd[index + 5] = sr.y / sr.height;
        // mul to uv
        vd[index + 6] = sr.width / tex.width;
        vd[index + 7] = sr.height / tex.height;
        var fd = EMPTY_TRANSFORM;
        if (this.transform) {
            fd = this._fragConstantData;
            fd.set(this.transform._rawData);
            for (var i = 0; i < 4; i++)
                fd[i + 4] /= 255;
            // disable ALPHA offset, because can't allowed in PMA mode
            fd[7] = 0;
        }
        var context = stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.VERTEX, vd);
        context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, fd);
    };
    Filter3DCopyPixelTaskWebGL.prototype.deactivate = function (stage) {
    };
    return Filter3DCopyPixelTaskWebGL;
}(Filter3DTaskBaseWebGL));
export { Filter3DCopyPixelTaskWebGL };
